import {combineReducers} from 'redux';
import Common from './Common';
import Dashboard from './Dashboard';
import Blogs from './Blogs';

const reducers = () =>
  combineReducers({
    dashboard: Dashboard,
    common: Common,
    blogs: Blogs,
  });
export default reducers;
